import {
    StyleSheet
} from "react-native";
import type {
    AnimatedIconLayerBlurConstantType
} from "./type";
import {
    getAnimatedIconPartValue
} from "../parts/stylesheet";
import {
    ANIMATED_ICON_BLUR_FULL_SIZE
} from "../../constant";

const stylesheet = StyleSheet.create({
    svg: {
        ...StyleSheet.absoluteFill
    }
});

export const getAnimatedIconLayerBlur = ({
    progress,
    parts,
    size
}: AnimatedIconLayerBlurConstantType): number => {
    const blurPart = parts.find((part) => part?.ranges.blur);

    if(!blurPart) {
        return 0;
    }

    return getAnimatedIconPartValue({
        property: "blur",
        part: blurPart,
        progress
    }) * Math.min(size / ANIMATED_ICON_BLUR_FULL_SIZE, 1);
};
export default stylesheet;
